/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const ConstraintWidth = styled(Box)(({theme}) => ({
  width: '1440px',
  margin: '0 auto',
  padding: 0,

  [`${theme.breakpoints.down('xl')}`]: {
    width: '100%',
    margin: 0,
    padding: theme.spacing(0, 6),
  },
}));

export const HeadingBox = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(8),
}));

export const HeadingText = styled(Typography)(({theme}) => ({
  maxWidth: '700px',
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '40px',
  fontWeight: 400,
  lineHeight: 'normal',
}));

export const PurposeSwitchBox = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(8),
}));

export const MainContentBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(8, 0),
  background: 'linear-gradient(180deg, rgba(45, 46, 50, 0.25) 0%, rgba(74, 75, 79, 0.25) 100%)',
}));
